import { type Pinia } from 'pinia'
import { useSouthpoleStore } from '~/store/southpole'
import { useAuthStore } from '~/store/auth'
import { useIntegrationsStore } from '~/store/integrations'
import { useNotificationsStore } from '~/store/notifications'
import { useSidebarStore } from '~/store/sidebar'
import { useCompaniesStore } from '~/store/companies'
import { useUploadProgressStore } from '~/store/upload-progress'
import { useUserSettingsStore } from '~/store/userSettings'
import { useCancelTokenStore } from '~/store/cancel-token'

export default defineNuxtPlugin({
  name: 'store',

  parallel: true,

  setup({ $pinia }) {
    // Typing $pinia instead of using it directly
    const _pinia = $pinia as Pinia

    if (!_pinia) return

    return {
      provide: {
        store: {
          southpole: useSouthpoleStore(_pinia),
          auth: useAuthStore(_pinia),
          integrations: useIntegrationsStore(_pinia),
          notifications: useNotificationsStore(_pinia),
          sidebar: useSidebarStore(_pinia),
          companies: useCompaniesStore(_pinia),
          uploadProgress: useUploadProgressStore(_pinia),
          userSettings: useUserSettingsStore(_pinia),
          cancelToken: useCancelTokenStore(_pinia),
        },
      },
    }
  },
})
